export type UnitTypeConfig = {
    id: string;
    labelKey: string;
    power: number;
    foodPerHex: number;
    weaponCost: number;
};

export abstract class UnitType {
    constructor(protected config: UnitTypeConfig) {}

    get id(): string {
        return this.config.id;
    }

    get labelKey(): string {
        return this.config.labelKey;
    }

    get power(): number {
        return this.config.power;
    }

    get foodPerHex(): number {
        return this.config.foodPerHex;
    }

    get weaponCost(): number {
        return this.config.weaponCost;
    }

    powerFor(count: number): number {
        return this.config.power * count;
    }
}

export class BasicUnitType extends UnitType {}

export type UnitGroup = { type: string; count: number };

export class UnitRoster {
    private types: Map<string, UnitType>;

    constructor(types: UnitType[]) {
        this.types = new Map(types.map((unit) => [unit.id, unit]));
    }

    get(id: string): UnitType | null {
        return this.types.get(id) || null;
    }

    getAll(): UnitType[] {
        return Array.from(this.types.values());
    }

    totalUnits(groups: UnitGroup[]): number {
        return groups.reduce((sum, group) => sum + group.count, 0);
    }

    totalPower(groups: UnitGroup[]): number {
        return groups.reduce((sum, group) => {
            const unit = this.get(group.type);
            if (!unit) return sum;
            return sum + unit.powerFor(group.count);
        }, 0);
    }
}
